import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  CompanyNamePayload,
  CompanyNameSuccess,
} from 'redux/types/CompanyName.type';

export interface ComapnyName {
  loading: boolean;
  error: string | null;
  data: any;
  pincodeData: any;
}

export const agencyComapnyNameInitialState: ComapnyName = {
  data: null,
  loading: false,
  error: null,
  pincodeData: null,
};

export const agencyComapnyNameSlice = createSlice({
  name: 'agencyComapnyNames',
  initialState: agencyComapnyNameInitialState,
  reducers: {
    getAllRequest: (state, action: PayloadAction<CompanyNamePayload>) => {
      state.loading = true;
      state.error = null;
    },
    getAllSuccess: (state, action: PayloadAction<CompanyNameSuccess>) => {
      state.loading = false;
      const { data, companyName } = action.payload;
      if (companyName === '' && state.data !== null) {
        state.data = [...state.data, ...data];
      } else {
        state.data = data;
      }
    },
    getAllFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getPincodeDetailsRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getPincodeDetailsSuccess: (state, action) => {
      state.loading = false;
      state.pincodeData = action.payload;
    },
    getPincodeDetailsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getAllRequest,
  getAllSuccess,
  getAllFailure,
  getPincodeDetailsRequest,
  getPincodeDetailsSuccess,
  getPincodeDetailsFailure,
} = agencyComapnyNameSlice.actions;

export default agencyComapnyNameSlice.reducer;
